exports = module.exports = require("../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".auditlog-entries table,.filter{margin-top:15px}.auditlog-entries table th{color:#333;font-weight:700}.auditlog-entries th.small-col{width:200px}.auditlog-entries th.tiny-col{width:100px}.auditlog-entries tbody.details-visible{border-left:4px solid #2980b9}.auditlog-entries tr.toggle-details{cursor:pointer}.auditlog-entries-details dd:not(:last-child){border-bottom:1px solid #ececec;margin-bottom:5px;padding-bottom:5px}.auditlog-entries-details td{padding-top:13px!important;padding-left:13px!important}.auditlog-entries-details dl{margin-bottom:13px}.auditlog-entries-details .row{margin-bottom:0}.table-hover>tbody.auditlog-entry>tr.auditlog-entries-details:hover{background:none}.auditlog-entries tbody.details-visible td.auditlog-message{font-weight:700}.popover-wide{max-width:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/node_modules/css-loader!./src/web/AuditLogEntriesStyle.css
// module id = 542
// module chunks = 0